import React, { Component } from 'react'
import './krishak.css';
import Utilities from '../../global/Utilities';
import Select from 'react-select';
import HybridDataField from '../common/crop/HybridDataField';
import ApiServices from '../../providers/ApiServices';
import { ADD_KRISHAK_SCREEN, SYNC_SERVICE } from '../../global/Constants';
import SyncServices from '../../providers/SyncServices';

class BrandLoyalty extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isValuesUpdated: false,
            isUSBrand: false,
            selectedCropIds: [],
            isOtherBrand: false,
            selectedUSBrands: [],
            selectedOtherBrands: [],
            otherBrands: [],
            usBrands: [],
            krishakParam: {},
            fields: {},
            selectedUnits: {},
            allWeightUnits: [],
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps) {
            let selectedCropIds = newProps.selectedCropIds;

            if (selectedCropIds && selectedCropIds !== undefined && selectedCropIds.length !== 0) {
                //Utilities.LogPrint("selectedCropIds", selectedCropIds);

                const stateId = newProps?.stateId;
                //Utilities.LogPrint("StateId", stateId);

                this.setState({ selectedCropIds: selectedCropIds });
                this.getHybridByMultiCrop(selectedCropIds);
                this.getCompetitorHybridByMultiCrop(selectedCropIds, stateId);

            }
        }
    }

    componentDidMount() {
        // this.getKrishakParam();
        this.getAllWeightUnit();

        let krishakData = this.props.krishakData;
        if (krishakData) {
            let otherBrandsData = [];
            if (krishakData.krishak_other_brands && krishakData.krishak_other_brands?.length > 0) {
                this.setState({ isOtherBrand: true });
                for (var i = 0; i < krishakData.krishak_other_brands.length; i++) {
                    Utilities.LogPrint("krishakDataBrandLoyalty", krishakData.krishak_other_brands[i].quantity);

                    let competitor_hybrid = krishakData.krishak_other_brands[i].competitor_hybrid;
                    competitor_hybrid["quantity"] = krishakData.krishak_other_brands[i].quantity;
                    otherBrandsData.push(competitor_hybrid);
                }
            }
            this.setState({
                isUSBrand: true,
                //isOtherBrand: true,
                selectedUSBrands: krishakData.krishak_hybrid_purchaseds.map(({ hybrid_id: value, hybrid_name: label, ...rest }) => ({ value, label, ...rest })),
                selectedOtherBrands: otherBrandsData.map(({ competitor_hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }))
            }, () => {
                this.updateNextButton();
            })
        }
        this.updateNextButton();
    }

    handleUnitChange = (field, event) => {
        let selectedUnits = this.state.selectedUnits;
        selectedUnits[field] = event.target.value;
        this.setState({ selectedUnits });
        this.updateNextButton();
    };

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || typeof value === "undefined") {
            value = defaultValue;
        }
        return value;
    }

    _getUnitSelected(fieldName, defaultValue) {
        const { selectedUnits } = this.state;
        let value = selectedUnits[fieldName];
        if (value === null || typeof value === "undefined") {
            value = defaultValue;
        }
        return value;
    }

    _handleValueChange = (field, e) => {
        if (!this.state.isValuesUpdated) {
            this.setState({ isValuesUpdated: true });
        }
        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({ fields });
        this.updateNextButton();
    };

    updateNextButton = () => {

        const { selectedUSBrands, allWeightUnits, selectedOtherBrands, isOtherBrand, isUSBrand } = this.state;
        let isUsBrandSelected = false;
        let isOtherBrandSelected = false;
        let purchasedBrands = [];

        const newSelectedUSBrands = [];
        const newSelectedOtherBrands = [];

        if (isUSBrand) {
            purchasedBrands.push(0);
        }
        if (isOtherBrand) {
            purchasedBrands.push(1);
        }

        for (var i = 0; i < selectedUSBrands.length; i++) {
            const crop = this._getFieldValue(selectedUSBrands[i].label, selectedUSBrands[i].quantity);
            const unitId = (allWeightUnits !== undefined && allWeightUnits.length !== 0) ? this._getUnitSelected(selectedUSBrands[i].label, allWeightUnits[1].value) : 1;
            let selectedWeightUnit = allWeightUnits.find(item => item.value === parseInt(unitId));
            Utilities.LogPrint("selectedWeightUnit", (selectedWeightUnit !== undefined) ? selectedWeightUnit.label : "");

            let usCropToAdd = {
                quantity: parseInt(crop),
                weight_unit_id: unitId,
                hybrid_id: selectedUSBrands[i].value,
                hybrid_name: selectedUSBrands[i].label,
                weight_unit_name: (selectedWeightUnit !== undefined) ? selectedWeightUnit.label : ""
            }

            newSelectedUSBrands.push(usCropToAdd);

            isUsBrandSelected = !this.state.isValuesUpdated ? (selectedUSBrands[i].quantity !== "" && selectedUSBrands[i].quantity !== 0) : (crop !== "" && crop !== 0);
        }

        for (var i = 0; i < selectedOtherBrands.length; i++) {
            const crop = this._getFieldValue(selectedOtherBrands[i].label, selectedOtherBrands[i].quantity);
            const unitId = (allWeightUnits !== undefined && allWeightUnits.length !== 0) ? this._getUnitSelected(selectedOtherBrands[i].label, allWeightUnits[0].value) : 1;
            let otherCropToAdd = {
                quantity: parseInt(crop),
                weight_unit_id: unitId,
                competitor_hybrid_id: selectedOtherBrands[i].value,
                competitor_hybrid: {
                    competitor_hybrid_id: selectedOtherBrands[i].value,
                    season_name: selectedOtherBrands[i].label,
                    weight_unit_id: unitId,
                }
            }

            newSelectedOtherBrands.push(otherCropToAdd);
            isOtherBrandSelected = !this.state.isValuesUpdated ? (selectedOtherBrands[i].quantity !== "" && selectedOtherBrands[i].quantity !== 0) : (crop !== "" && crop !== 0);
        }

        //let isEnable = isUsBrandSelected && (isUSBrand || isOtherBrand);
        let isEnable = (isUsBrandSelected || isOtherBrandSelected) && (isUSBrand || isOtherBrand);
        // Utilities.LogPrint("_handleNextButton_handleNextButton", isOtherBrandSelected);

        if (isEnable) {
            var brand_loyalty = {
                brand_purchased: purchasedBrands,
                us_brands: newSelectedUSBrands,
                other_hybrid_brands: newSelectedOtherBrands
            };
        }

        // Utilities.LogPrint("_handleNextButton_handleNextButton", brand_loyalty);
        this.props._handleNextButton(true, brand_loyalty, "brand_loyalty");
    }

    getKrishakParam = () => {
        this.props.loaderCallback(true);
        try {
            ApiServices.getKrishakParam().then(response => {
                var status = response.success;
                if (status) {
                    const krishakParam = response.data;
                    this.setState({ krishakParam }, () => {
                        this.separateHybrids();
                    });
                    this.props.loaderCallback(false);
                    Utilities.LogPrint("getKrishakParam", krishakParam);
                } else {
                    Utilities.LogPrint("getKrishakParam", response);
                    this.props.loaderCallback(false);
                }
            }).catch(error => {
                this.props.loaderCallback(false);
                Utilities.LogPrint("getKrishakParam", error);
            });
        } catch (error) {
            this.props.loaderCallback(false);
            Utilities.LogPrint("getKrishakParam", error);
        }
    }

    getHybridByMultiCrop = (selectedCropIds) => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_HYBRID, SYNC_SERVICE.MASTER_TABLE).then(data => {
            Utilities.LogPrint("selectedCropIdsHybrid", selectedCropIds);
            if (data && data !== undefined && data.length > 0) {

                var filterData = [];
                for (var i = 0; i < selectedCropIds.length; i++) {
                    for (var j = 0; j < data.length; j++) {
                        if (data[j].crop_id === selectedCropIds[i]) {
                            filterData.push(data[j]);
                        }
                    }
                }

                this.setState({
                    usBrands: filterData.map(({ hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });

        // this.props.loaderCallback(true);
        // var body = JSON.stringify({
        //     crop_id: selectedCropIds,
        // });
        // try {
        //     ApiServices.getHybridByMultiCrop(body).then(response => {
        //         var status = response.success;
        //         if (status) {
        //             const krishakParam = response.data;
        //             this.setState({
        //                 usBrands: krishakParam.map(({ hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest })),
        //             })
        //             this.props.loaderCallback(false);
        //             Utilities.LogPrint("getHybridByMultiCrop", krishakParam);
        //         } else {
        //             Utilities.LogPrint("getHybridByMultiCrop", response);
        //             this.props.loaderCallback(false);
        //         }
        //     }).catch(error => {
        //         this.props.loaderCallback(false);
        //         Utilities.LogPrint("getHybridByMultiCrop", error);
        //     });
        // } catch (error) {
        //     this.props.loaderCallback(false);
        //     Utilities.LogPrint("getHybridByMultiCrop", error);
        // }
    }

    getCompetitorHybridByMultiCrop = (selectedCropIds, stateId) => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_DAKSH_COMPETITOR_HYBRID, SYNC_SERVICE.MASTER_TABLE).then(data => {
            Utilities.LogPrint("otherBrands", data);
            //Utilities.LogPrint("selectedCropIdsCompetitorHybrid", selectedCropIds);
            if (data && data !== undefined && data.length > 0) {

                var filterData = [];
                for (var i = 0; i < selectedCropIds.length; i++) {
                    for (var j = 0; j < data.length; j++) {
                        if (data[j].crop_id === selectedCropIds[i] && data[j].state_id === stateId) {
                            filterData.push(data[j]);
                        }
                    }
                }
                this.setState({
                    otherBrands: filterData.map(({ competitor_hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });

        // this.props.loaderCallback(true);
        // var body = JSON.stringify({
        //     crop_id: selectedCropIds,
        // });
        // try {
        //     ApiServices.getCompetitorHybridByMultiCrop(body).then(response => {
        //         var status = response.success;
        //         if (status) {
        //             const krishakParam = response.data;
        //             this.setState({
        //                 otherBrands: krishakParam.map(({ competitor_hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest })),
        //             })
        //             this.props.loaderCallback(false);
        //             Utilities.LogPrint("getCompetitorHybridByMultiCrop", krishakParam);
        //         } else {
        //             Utilities.LogPrint("getCompetitorHybridByMultiCrop", response);
        //             this.props.loaderCallback(false);
        //         }
        //     }).catch(error => {
        //         this.props.loaderCallback(false);
        //         Utilities.LogPrint("getCompetitorHybridByMultiCrop", error);
        //     });
        // } catch (error) {
        //     this.props.loaderCallback(false);
        //     Utilities.LogPrint("getCompetitorHybridByMultiCrop", error);
        // }
    }

    separateHybrids = () => {
        const { krishakParam } = this.state;
        this.setState({
            usBrands: krishakParam.US_brand.map(({ hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest })),
            otherBrands: krishakParam.competitor_hybrid.map(({ competitor_hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest })),
        })
    }

    onUSBrandChange = () => {
        this.setState({
            isUSBrand: !this.state.isUSBrand
        }, () => {
            this.updateNextButton();
        });
    }

    onOtherBrandChange = () => {
        this.setState({
            isOtherBrand: !this.state.isOtherBrand
        }, () => {
            this.updateNextButton();
        });
    }

    handleUSBrandClick = (e, brand) => {
        // e.preventDefault();
        const newArray = this.state.selectedUSBrands.slice(); // Create a copy


        if (newArray.some(e => e.brandId === brand.brandId)) {
            /* selectedCrops contains the element we're looking for */
            var index = newArray.indexOf(brand)
            if (index !== -1) {
                newArray.splice(index, 1);
            }
        } else {
            newArray.push(brand);
        }
        this.setState({ selectedUSBrands: newArray });
        //Utilities.LogPrint("selectedUSBrands", newArray.length);
    }

    getAllWeightUnit = () => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_WEIGHT_UNIT, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                this.setState({
                    allWeightUnits: data.map(({ weight_unit_id: value, name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });

        // var body = JSON.stringify({
        //     page: 1,
        //     perPage: 10,
        //     searchKey: "",
        //     sortBy: "created_at",
        //     sortOrder: "ASC"
        // });
        // try {
        //     ApiServices.getAllWeightUnit(body).then(response => {
        //         var status = response.success;
        //         if (status) {
        //             const newArrayOfObj = response.data.data.map(({ weight_unit_id: value, name: label, ...rest }) => ({ value, label, ...rest }));
        //             this.setState({ allWeightUnits: newArrayOfObj });
        //             Utilities.LogPrint("getAllWeightUnit", newArrayOfObj);
        //             this.updateNextButton();
        //         } else {
        //             Utilities.LogPrint("getAllWeightUnit", response);
        //             this.props.loaderCallback(false);
        //         }
        //     }).catch(error => {
        //         Utilities.LogPrint("getAllWeightUnit", error);
        //     });
        // } catch (error) {
        //     Utilities.LogPrint("getAllWeightUnit", error);
        // }
    }

    handleOtherBrandClick = (e, brand) => {
        // e.preventDefault();
        const newArray = this.state.selectedOtherBrands.slice(); // Create a copy


        if (newArray.some(e => e.brandId === brand.brandId)) {
            /* selectedCrops contains the element we're looking for */
            var index = newArray.indexOf(brand)
            if (index !== -1) {
                newArray.splice(index, 1);
            }
        } else {
            newArray.push(brand);
        }
        this.setState({ selectedOtherBrands: newArray });
        Utilities.LogPrint("selectedOtherBrands", newArray.length);
    }



    handleUSBrandsChange = selectedUSBrands => {
        this.setState({ selectedUSBrands }, () => {
            this.updateNextButton();
        });
    };

    handleOtherBrandsChange = selectedOtherBrands => {
        this.setState({ selectedOtherBrands }, () => {
            this.updateNextButton();
        });
    };

    render() {
        const { isVisible } = this.props;
        const { otherBrands, usBrands, allWeightUnits, selectedOtherBrands, selectedUSBrands, isUSBrand, isOtherBrand } = this.state;
        const selectedOtherBrandsListItem = selectedOtherBrands.map((hybrid, i) =>
            <HybridDataField allWeightUnits={allWeightUnits} handleUnitChange={this.handleUnitChange} hybrid={hybrid} key={i} _handleValueChange={this._handleValueChange} />
        );

        const selectedUSBrandsListItem = selectedUSBrands.map((hybrid, i) =>
            <HybridDataField allWeightUnits={allWeightUnits} handleUnitChange={this.handleUnitChange} hybrid={hybrid} key={i} _handleValueChange={this._handleValueChange} />
        );

        return (
            <div className={isVisible ? "row krishak-tab-body brand-loyalty-body" : "row krishak-tab-body brand-loyalty-body d-none"}>
                <div className="col-12">
                    <div className="form-group">
                        <label className="font-weight-medium">{ADD_KRISHAK_SCREEN.BRAND_PURCHASED}</label>
                        <div className="row">
                            <div className="col-lg-3 col-6 mt-md-3">
                                <label className="cutom-checkbox-container">
                                    {ADD_KRISHAK_SCREEN.US_BRANDS}
                                    <input type="checkbox" checked={isUSBrand} onChange={this.onUSBrandChange} />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            <div className="col-lg-3 col-6 mt-md-3 mb-md-3">
                                <label className="cutom-checkbox-container">
                                    {ADD_KRISHAK_SCREEN.OTHER_BRANDS}
                                    <input type="checkbox" checked={isOtherBrand} onChange={this.onOtherBrandChange} />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* US Hybrids Purchased */}

                    <div className={isUSBrand ? "dropdown" : "d-none"}>
                        <label className="font-weight-medium d-block">{ADD_KRISHAK_SCREEN.US_HYBRIDS_PURCHASED}</label>
                        <Select className=" max-w-360"
                            isMulti
                            value={selectedUSBrands}
                            onChange={this.handleUSBrandsChange}
                            options={usBrands}
                            placeholder={ADD_KRISHAK_SCREEN.SELECT_ONE_OR_MULTIPLE}
                            isClearable={true}
                        />
                    </div>

                    <div className={isUSBrand ? "form-group d-md-none" : "d-none"}>
                        <label className="font-weight-medium mt-md-3">{ADD_KRISHAK_SCREEN.US_HYBRIDS_PURCHASED} </label>
                        <Select className=" max-w-360"
                            isMulti
                            value={selectedUSBrands}
                            onChange={this.handleUSBrandsChange}
                            options={usBrands}
                            placeholder={ADD_KRISHAK_SCREEN.SELECT_ONE_OR_MULTIPLE}
                            isClearable={true}
                        />
                    </div>
                    <div className={isUSBrand ? "row mt-md-4" : "d-none"}>
                        {selectedUSBrandsListItem}
                    </div>

                    {/* Other Brand Hybrid Purchased */}

                    <div className={isOtherBrand ? "dropdown mt-3" : "d-none"}>
                        <label className="font-weight-medium d-block">{ADD_KRISHAK_SCREEN.OTHER_BRAND_HYBRIDS_PURCHASED}</label>
                        <Select className=" max-w-360"
                            isMulti
                            value={selectedOtherBrands}
                            onChange={this.handleOtherBrandsChange}
                            options={otherBrands}
                            placeholder={ADD_KRISHAK_SCREEN.SELECT_ONE_OR_MULTIPLE}
                            isClearable={true}
                        />
                    </div>

                    <div className={isOtherBrand ? "form-group mt-md-4 mt-2 d-md-none" : "d-none"}>
                        <label className="font-weight-medium">{ADD_KRISHAK_SCREEN.OTHER_BRAND_HYBRIDS_PURCHASED}</label>
                        <Select className=" max-w-360"
                            isMulti
                            value={selectedOtherBrands}
                            onChange={this.handleOtherBrandsChange}
                            options={otherBrands}
                            placeholder={ADD_KRISHAK_SCREEN.SELECT_ONE_OR_MULTIPLE}
                            isClearable={true}
                        />
                    </div>
                    <div className={isOtherBrand ? "row mt-md-4" : "d-none"}>
                        {selectedOtherBrandsListItem}
                    </div>
                </div>
            </div>

        )
    }
}

export default BrandLoyalty
